import React, { useContext } from 'react';
import classnames from 'classnames';
import DiscoveryContext from '../../../../../contexts/discoveryContext/contextV2';
import { outerContainer } from '../../../styles.module.css';
import { container, mapMode as mapModeStyle } from './styles.module.css';

const Header = ({ mapMode = false }) => {
  const {
    filters: {
      location: { name },
    },
  } = useContext(DiscoveryContext);

  const headerText =
    name === 'Custom Location'
      ? 'Hmm, looks like there are no events found in this area.'
      : `Hmm, looks like there are no events found around '${name}'.`;

  return (
    <div
      className={classnames(outerContainer, {
        [mapModeStyle]: mapMode,
      })}
    >
      <div className={container}>
        <h2>{headerText}</h2>
        <p>
          {mapMode
            ? 'To get more results, try a new search by adjusting your location, filters or zooming out of the map.'
            : 'To get more results, try a new search by adjusting your location or filters'}
        </p>
      </div>
    </div>
  );
};

export default Header;
